import { Alert } from 'antd'
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import * as actions from '../actions'
import { compose } from '../common/utils'
import EstimateForm from '../components/estimate-form'
import * as API from '../services/api'
import './estimate.less'

class EstimatePage extends React.Component {
  state = {
    isSubmitting: false,
    mode: 'form',
    errMsg: null,
    approvedByName: ''
  }

  componentDidMount() {
    const id = this.props.match.params.id
    this.props.loadEstimate(id, this.props.preview)
  }

  onSubmitWorkareas = (formData) => {
    this.setState({ isSubmitting: true, errMsg: null })

    const data = {
      id: this.props.estimate.id,
      approvedWorkAreasIds: formData.workareas,
      approvedByName: formData.approvedByName
    }
    return API.approveProposal(data).then(() => {
      this.setState({ isSubmitting: false, mode: 'success', approvedByName: formData.approvedByName })
    },
      e => {
        this.setState({ isSubmitting: false, errMsg: e.messag })
      })
  }

  render() {
    const { errMsg, mode } = this.state
    const name = this.state.approvedByName && this.state.approvedByName.split(' ')
    const firstName = name && name.length && name[0]

    return <>
      <div className="estimate-container content-box">
        {this.props.preview &&
          <div className="preview-banner">
            Preview
          </div>
        }
        <div className="image logo">
          {this.props.estimate.tenantLogoUrl && <img src={this.props.estimate.tenantLogoUrl} alt="Logo" />}
        </div>

        {mode === 'form'
          ? <div>
            <h2 className="text-center">{this.props.estimate.tenantName}</h2>
            <h3>{this.props.user.customerName}</h3>
            <h3>{this.props.estimate.projectName}</h3>
            <p>Please confirm your workareas</p>
            {this.props.estimate.id ? <EstimateForm
              key={this.props.estimate.id}
              defaultEstimate={this.props.estimate}
              onSubmit={this.onSubmitWorkareas}
              isSubmitting={this.state.isSubmitting}
              preview={this.props.preview}
            />
              : <h3>Estimate could not be found</h3>
            }
          </div>
          : null}

        {mode === 'success'
          ? <div>
            <h2 className="text-center">{this.props.estimate.tenantName}</h2>
            <h1 className="text-center">Thank you {firstName}!</h1>
            {this.props.estimate.autoSubmitDownPaymentInvoice ? <div className="text-center">
              <p>You will receive an invoice in your email inbox for the down payment on the work that you just approved. Please make payment on that invoice. As soon as your down payment invoice is paid, we will be able to schedule your project.</p>
              <p>We appreciate the opportunity to work with you. You just made our day!</p>
              <p className="text-small">*if you do not receive an invoice in your email, please make sure to check your spam or junk folders</p>
            </div>
              : <div className="text-center">
                <p>Your sales contact will follow up with you to provide you with the down payment invoice for the work you just approved.</p>
                <p>We appreciate the opportunity to work with you. You just made our day!</p>
              </div>}

            <h3>{this.props.estimate.projectName}</h3>
            <div className="success-message">
              <Alert message={'Successfully Submitted'} type="success" showIcon />
            </div>
          </div>
          : null}

        {errMsg && errMsg.length
          ? <div>
            <div className="error-message">
              <Alert message={errMsg} type="error" showIcon />
            </div>
          </div>
          : null}

      </div>
    </>
  }
}

export default compose(
  connect(
    (state, ownProps) => ({
      estimate: state.estimate.detail,
      user: state.userInfo,
      preview: ownProps.preview
    }),
    dispatch => bindActionCreators({ ...actions }, dispatch)
  ),
  withRouter
)(EstimatePage)
